"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transport = void 0;
const Logger_1 = require("../utils/Logger");
const __1 = require("..");
const logger = new Logger_1.Logger('Transport');
class Transport {
    constructor(name) {
        this.type = __1.TransportType.POST_MESSAGE;
        this._isConnected = __1.TransportStatus.NOT_CONNECTED;
        this.listeners = [];
        this.name = name;
    }
    get connectionStatus() {
        return this._isConnected;
    }
    static async isAvailable() {
        return Promise.resolve(false);
    }
    async connect() {
        logger.log('connect');
        this._isConnected = __1.TransportStatus.CONNECTED;
        return;
    }
    async reconnect() {
        logger.log('reconnect');
        return;
    }
    async send(message, recipient) {
        logger.log('send', message, recipient);
        return;
    }
    async addListener(listener) {
        logger.log('addListener');
        this.listeners.push(listener);
        return;
    }
    async removeListener(listener) {
        logger.log('removeListener');
        this.listeners = this.listeners.filter((element) => element !== listener);
        return;
    }
    async notifyListeners(message, connectionInfo) {
        logger.log('notifyListeners');
        if (this.listeners.length === 0) {
            logger.warn('notifyListeners', '0 listeners notified!', this);
        }
        else {
            logger.log(`Notifying ${this.listeners.length} listeners`, this);
        }
        this.listeners.forEach((listener) => {
            listener(message, connectionInfo);
        });
        return;
    }
}
exports.Transport = Transport;
//# sourceMappingURL=Transport.js.map